const faviconVariants = {
  LOCAL: {
    type: 'warning',
  },
  DEV: {
    type: 'info',
  },
  TEST: {
    type: 'success',
  },
};

export const setFavicon = (env: string | undefined) => {
  if (!env || !['LOCAL', 'DEV', 'TEST'].includes(env)) {
    return null;
  }

  const variant = faviconVariants[env as keyof typeof faviconVariants];
  const favicon = document.head.appendChild(document.createElement('link'));
  favicon.rel = 'icon';
  favicon.href = `/favicons/favicon-${variant.type}.ico`;
};
